import { Link } from "react-router-dom";

/**
 * Friendly, illustrated empty state used across the expert dashboard.
 * Ties into the SpørgMig visual style with a soft parchment card,
 * SVG glyph, plain-language title + description and optional CTAs.
 */
export default function EmptyState({
  icon,
  title,
  description,
  primary,     // { label, to, onClick, testid }
  secondary,   // { label, to, onClick, testid }
  variant = "default", // default | compact
  testid,
}) {
  const compact = variant === "compact";
  return (
    <div
      className={`card-outline flex flex-col items-center text-center ${compact ? "px-4 py-6" : "px-5 py-10"} bg-gradient-to-b from-brand-wash to-brand-soft`}
      data-testid={testid || "empty-state"}
    >
      <div className={`flex items-center justify-center rounded-full bg-white/70 border border-brand-line ${compact ? "w-12 h-12" : "w-16 h-16"}`}>
        {icon}
      </div>
      <h3 className={`mt-3 font-display font-semibold text-brand-ink ${compact ? "text-sm" : "text-base"}`}>{title}</h3>
      {description && (
        <p className={`mt-1 text-brand-muted max-w-md ${compact ? "text-[12px]" : "text-sm"}`}>{description}</p>
      )}
      {(primary || secondary) && (
        <div className="mt-4 flex items-center gap-2 flex-wrap justify-center">
          {primary && (
            primary.to ? (
              <Link to={primary.to} className="btn-primary text-xs !py-2" data-testid={primary.testid}>{primary.label}</Link>
            ) : (
              <button onClick={primary.onClick} className="btn-primary text-xs !py-2" data-testid={primary.testid}>{primary.label}</button>
            )
          )}
          {secondary && (
            secondary.to ? (
              <Link to={secondary.to} className="text-xs px-3 py-2 rounded-full border border-brand-line text-brand-ink hover:bg-white" data-testid={secondary.testid}>{secondary.label}</Link>
            ) : (
              <button onClick={secondary.onClick} className="text-xs px-3 py-2 rounded-full border border-brand-line text-brand-ink hover:bg-white" data-testid={secondary.testid}>{secondary.label}</button>
            )
          )}
        </div>
      )}
    </div>
  );
}

